<template>
  <div class="comp-jobs" :class="{'is-client': IS_CLIENT}">
    <h1 class="headline">JOBS</h1>

    <div class="toolbar">
      <div class="btns">
        <div v-if="!IS_CLIENT">
          <button type="button" class="btn btn-outline-black w180" @click="showModalAdd = true">+ New Job</button>
          <button type="button" class="btn btn-outline-gray icon-printer" @click="printJobs"></button>
        </div>
        <template v-else>
          <button type="button" class="btn btn-outline-black" @click="showRequestJobModal = true">Request New Job</button>
        </template>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" placeholder="SEARCH JOBS..." v-model="keyword" @change="getJobs()">
        </div>
        <v-select v-model="ftStatus" :options="statusOpts" class="ft-type" :reduce="item => item.value"
          :searchable="false" :placeholder="'ALL STATUSES'"></v-select>
        <v-select v-if="!IS_CLIENT" v-model="ftClientId" :options="allClients" class="ft-client" :reduce="item => item.id"
          label="name" :searchable="true"  placeholder="ALL CLIENTS"></v-select>
      </div>
    </div>

    <div class="table-responsive overflow-none">
      <table class="table table-sm table-hover td-pl td-pr">
        <thead>
          <tr>
            <th><a href="javascript:;" data-sort-field="job_no" @click="doSort($event)" :class="IS_CLIENT?'asc':''" class="sort">JOB NO</a></th>
            <th v-if="!IS_CLIENT"><a href="javascript:;" data-sort-field="client_name" @click="doSort($event)"  class="sort asc">CLIENT</a></th>
            <th><a href="javascript:;" data-sort-field="job_name" @click="doSort($event)" class="sort">JOB NAME</a></th>
            <th><a href="javascript:;" data-sort-field="job_status" @click="doSort($event)" class="sort">STATUS</a></th>
            <th><a href="javascript:;" data-sort-field="job_due_date" @click="doSort($event)" class="sort">DUE DATE</a></th>
            <th v-if="IS_SUPER_ADMIN" class="text-right"><a href="javascript:;">QUOTE VALUE</a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(job, index) in jobs" :key="index" style="cursor: pointer;">
            <td @click="gotoJob(job.id)">{{ (job.client?job.client.code:'') + job.id }}</td>
            <td v-if="!IS_CLIENT">
              <router-link :to="{ name: 'client', params: { itemId: job.client.id } }" class="black">{{ job.client.name }}</router-link>
            </td>
            <td @click="gotoJob(job.id)">{{ job.name }}</td>
            <td @click="gotoJob(job.id)">{{ job.status | statusToUCWords }}</td>
            <td @click="gotoJob(job.id)">{{ job.due_date | toHumanDate('Do MMM YYYY') }}</td>
            <td v-if="IS_SUPER_ADMIN" align="right">{{ job.quote_value | moneyFormat(0) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!loading && hasFilters && jobs.length == 0" class="alert alert-warning">
      No jobs found
    </div>

    <div v-if="!IS_CLIENT" class="footbar">
      <div class="container">
        <div class="inn">
          <label class="lb">TOTAL JOBS</label>
          <span class="total">{{ jobs.length }}<span v-if="IS_SUPER_ADMIN"> | {{ totalQuoteValue | moneyFormat(0) }}</span></span>
        </div>
      </div>
    </div>

    <modal-add-job v-model="showModalAdd" :clientId="client_id" @job-created="onJobCreated"></modal-add-job>
    <modal-add-job-request v-model="showRequestJobModal" @close="onJobRequestClose"></modal-add-job-request>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import jquery from "jquery"
  import ServiceJob from '@/services/job'
  import ModalAddJob from './ModalAddJob'
  import ModalAddJobRequest from '@/components/global/ModalAddJobRequest'

export default {
  components: {
    ModalAddJob,
    ModalAddJobRequest
  },
  data () {
    return {
      loading: false,
      ftStatus: '',
      ftClientId: '',
      showModalAdd: false,
      showRequestJobModal: false,
      jobs: [],
      client_id: null,
      keyword: '',
      excluding_statuses: ['completed', 'invoiced', 'pending'],
      sort: 'job_no',
      order: 'asc'
    }
  },
  watch: {
    ftStatus: function () {
      this.getJobs();
    },
    ftClientId: function () {
      this.getJobs();
    }
  },
  computed: {
    ...mapGetters(['IS_CLIENT', 'CURRENT_USER', 'IS_SUPER_ADMIN']),
    ...mapState({
      allClients: state => state.option.clients,
      jobStatuses: state => state.option.jobStatuses
    }),
    statusOpts () {
      let self = this, opts = [];
      for(var i in self.jobStatuses){
        if(self.IS_CLIENT && ['testing', 'invoiced'].indexOf(self.jobStatuses[i]) != -1) {
          continue;
        }
        opts.push({label: window.stringToUCWords(self.jobStatuses[i]), value: self.jobStatuses[i]});
      }
      return opts;
    },
    hasFilters () {
      let self = this;
      return self.ftStatus != '' || self.ftClientId != '' || self.keyword != '';
    },
    totalQuoteValue () {
      let self = this, total = 0;
      for(var i in self.jobs){
        total += self.jobs[i].quote_value;
      }
      return total;
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      this.showRequestJobModal = false;
      if(self.IS_CLIENT) {
        self.client_id = self.CURRENT_USER.client_id;
      } else {
        self.sort = 'client_name';
      }
      self.getJobs();
    },
    onJobCreated ( job ) {
      let self = this;
      self.$router.push({
        name: 'job',
        params: {
          jobId: job.id
        }
      });
    },
    doViewAll () {
      let self = this;
      self.keyword = '';
      self.ftStatus = '';
      self.ftClientId = '';
      self.getJobs();
    },
    _getParams(){
      let self = this,
        params = {
          ipp: 'all'
        };
      if ( self.ftStatus !== '' ) {
        params.status = self.ftStatus;
      }
      if ( self.ftClientId !== '' ) {
        params.client_id = self.ftClientId;
      }
      if ( self.keyword !== '' ) {
        params.kw = self.keyword;
      }

      if(self.IS_CLIENT){
        params['client_id'] = self.CURRENT_USER.client_id;
      }
      params['sort'] = self.sort;
      params['order'] = self.order;
      return params;
    },
    getJobs () {
      let self = this, params = self._getParams();
      self.loading = true;
      if (!self.ftStatus) {
        /* Exclude all 'Completed' and 'Invoiced' jobs - it will become unworkable */
        params['exclude_status'] = self.excluding_statuses;
      }

      if (!self.hasFilters && !self.IS_SUPER_ADMIN && !self.IS_CLIENT) {
        params['user_id'] = self.CURRENT_USER.id;
      }
      ServiceJob.getJobs(params, resp => {
        self.jobs = resp;
        self.loading = false;
      });
    },
    printJobs () {
      let self = this, params = self._getParams();
      if (!self.ftStatus) {
        /* Exclude all 'Completed' and 'Invoiced' jobs - it will become unworkable */
        params['exclude_status'] = self.excluding_statuses;
      }
      if (!self.IS_SUPER_ADMIN) {
        params['no_quote_value'] = 1;
      }
      ServiceJob.printJobs(params, resp => {
        window.downloadFromBlob(resp.data, 'jobs.pdf');
      });
    },
    gotoJob(jobId) {
      this.$router.push({name: 'job', params: {jobId: jobId}});
    },
    doSort (event) {
      let self = this, params = self._getParams(), header = event.target;

      // Go through all header and reset the sort class
      jquery('.sort').not(header).attr('class', 'sort');

      if (typeof header.dataset.sortField != 'undefined') {
        params['sort'] = header.dataset.sortField;
        if (header.className.indexOf('asc') == -1) {
          /* Not sort or in desc */
          params['order'] = 'asc';
          header.className = header.className.replace(' desc', '') + ' asc';
        } else if (header.className.indexOf('desc') == -1) {
          params['order'] = 'desc';
          header.className = header.className.replace(' asc', '') + ' desc';
        }
        self.sort = params['sort'];
        self.order = params['order'];
        self.loading = true;
        if (!self.ftStatus) {
          /* Exclude all 'Completed' and 'Invoiced' jobs - it will become unworkable */
          params['exclude_status'] = self.excluding_statuses;
        }
        ServiceJob.getJobs(params, resp => {
          self.jobs = resp;
          self.loading = false;
        });
      }
    },
    onJobRequestClose () {
      this.showRequestJobModal = false;
    },
  }
}
</script>
